import { Environment } from './environment.interface';

// Ambiente QA: https://qa-reclutamiento2027.ieeg.mx
// Ambiente nuevo, creado con los stacks de deploy/. A diferencia de development
// y production, que consumen la API por la URL cruda de API Gateway, QA nace
// apuntando al dominio propio.
export const environment: Environment = {
  name: 'qa',
  production: true,
  apiUrl: 'https://api.qa-reclutamiento2027.ieeg.mx',
  urlDataBucket: 'https://s3.amazonaws.com/data.qa-reclutamiento.ieeg.mx/',
  apiGlobalUrl: 'https://api.global.ieeg.mx/',

  // Login Azure
  // OJO: hay que registrar https://qa-reclutamiento2027.ieeg.mx como URI de
  // redirección en la aplicación de Azure AD, o MSAL rechaza el login.
  authorityAzure: 'https://login.microsoftonline.com/6d88d07c-1672-4d16-ab8c-3af2ef736fe7',
  clientIdAzure: 'ae04b56b-8154-4a59-aac8-8ead60472bd2',
  meAzure: 'https://graph.microsoft.com/v1.0/me',
  redirectAplicationAzure: 'https://qa-reclutamiento2027.ieeg.mx',
  scopesAzure: 'api://a9333b79-0578-4377-80d6-f69af15b23ab/Auth.AD',
};
